import { Navigate, Outlet } from "react-router";
import { useAuth } from "../views/AuthProvider"

export default function ProtectedRoutes() {
    const { isAuthenticated } = useAuth();

    if(!isAuthenticated) {
        return <Navigate to="/iniciar" replace />
    }

    return <Outlet />
}
